const unparkRoutes = {
  index: {
    path: 'index.maneuver.unpark',
    url: '/degarage',
  },
  selectWagons: {
    path: 'index.maneuver.unpark.wagon',
    url: '/selection-wagons',
  },
  createTrain: {
    path: 'index.maneuver.unpark.createTrain',
    url: '/creation-train',
  },
  report: {
    path: 'index.maneuver.unpark.report',
    url: '/rapport',
  },
}

export default unparkRoutes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/unpark/routes.js